import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '../../../../../Modal/Modal';
import {labels} from '../../../../../../../util/utils';
import {setIsModalOpen} from '../../../../../../../actions/setismodalopen';
import Utility from '../../../../../../../util/utilityfunctions';

import {ModalChildEntityListItem} from './ChildEntityListItem';

function DisplayAllItemsModal({className, allIds, nameKey, selector, title, header, setIsOpen, onRemove, fatherId, slice}) {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setIsModalOpen(true));
		return () => {
			dispatch(setIsModalOpen(false));
		};
	}, []);

	let allIdsSorted = useSelector((state) => {
		let entities =  allIds.map((id) => state.bodiesSpecial[slice]?.byId[id]);
		Utility.sortAlphaNumeric(entities, nameKey);
		return entities.map((entity) => entity.id);
	});

	return (
		<Modal
			className={className}
			show
			modalsize={'medium'}
			title={title}
			showButtons
			confirmBtnTitle={labels.save}
			onHide={() => {
				setIsOpen(false);
			}}
			onOkClick={() => {
				setIsOpen(false);
			}}
			closeBtnTitle={labels.cancelLabel}
			closeTitle={labels.close}
		>
			<section className="customScrollbar">
				<div>{header}</div>
				{allIdsSorted.map((id) => {
					return (
						<ModalChildEntityListItem
							id={id}
							selector={selector}
							nameKey={nameKey}
							onRemove={onRemove}
							fatherId={fatherId}
							isModal
						/>
					);
				})}
			</section>
		</Modal>
	);
}

DisplayAllItemsModal.propTypes = {
	allIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	nameKey: PropTypes.string.isrequired,
	selector: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	header: PropTypes.node.isRequired,
	setIsOpen: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	fatherId: PropTypes.number.isRequired
};

const StyledDisplayAllItemsModal = styled(DisplayAllItemsModal)`
	.child-entity-count,
	.child-entity-name,
	.parent-entity-object-name {
		font-weight: 600;
	}
	.display-all-items-modal-header {
		display: block;
		padding: var(--px-20);
		font-size: var(--px-16);
	}
`;

export default StyledDisplayAllItemsModal;
